import { makeAutoObservable } from "mobx";
import HistoricalBaselineData from "./HistoricalBaselineData";
import TaskPreBaseline from "./TaskPreBaseline";

export default class TaskPackagePreBaseline {
  constructor(
    code,
    id,
    parent,
    name,
    plannedStartDate,
    plannedEndDate,
    plannedCost,
    plannedDuration,
    historicalBaselineData,
    tasks,
    taskPackages
  ) {
    this.code = code;
    this.id = id;
    this.name = name;
    this.parent = parent;
    this.plannedCost = plannedCost;
    this.plannedDuration = plannedDuration;
    this.plannedStartDate = plannedStartDate;
    this.plannedEndDate = plannedEndDate;
    this.historicalBaselineData =
      historicalBaselineData === null || historicalBaselineData === undefined
        ? []
        : historicalBaselineData;
    this.tasks = tasks !== null ? tasks : [];
    this.taskPackages = taskPackages !== null ? taskPackages : [];

    makeAutoObservable(this);
  }

  depthFirstTraversal() {
    let stack = [];
    stack.push(this);
    for (let tp of this.taskPackages) {
      if (Array.isArray(tp.taskPackages)) {
        stack = stack.concat(tp.depthFirstTraversal());
      }
    }

    if (Array.isArray(this.tasks)) {
      stack = stack.concat(this.tasks);
    }

    return stack;
  }

  toJS() {
    return {
      code: this.code,
      id: this.id,
      name: this.name,
      parent: this.parent,
      plannedStartDate: this.plannedStartDate,
      plannedEndDate: this.plannedEndDate,
      plannedCost: this.plannedCost,
      plannedDuration: this.plannedDuration,
      historicalBaselineData: this.historicalBaselineData.map((data) =>
        data.toJS()
      ),
      tasks: this.tasks.map((entry) => entry.toJS()),
      taskPackages: this.taskPackages.map((entry) => entry.toJS()),
    };
  }

  static fromJS(store, object, parent) {
    const taskPackagePreBaseline = new TaskPackagePreBaseline();
    if (object != null) {
      taskPackagePreBaseline.name = object.name;
      taskPackagePreBaseline.id = object.id;
      taskPackagePreBaseline.code = object.code;
      taskPackagePreBaseline.parent = parent;
      taskPackagePreBaseline.plannedStartDate = object.plannedStartDate;
      taskPackagePreBaseline.plannedEndDate = object.plannedEndDate;
      taskPackagePreBaseline.plannedCost = object.plannedCost;
      taskPackagePreBaseline.plannedDuration = object.plannedDuration;
      taskPackagePreBaseline.historicalBaselineData =
        object.historicalBaselineData.map((data) =>
          HistoricalBaselineData.fromJS(data)
        );
      taskPackagePreBaseline.tasks = object.tasks.map((savedTask) => {
        return TaskPreBaseline.fromJS(store, savedTask, object.id);
      });
      taskPackagePreBaseline.taskPackages = object.taskPackages.map(
        (savedTaskpackage) => {
          return TaskPackagePreBaseline.fromJS(
            store,
            savedTaskpackage,
            object.id
          );
        }
      );
    }
    return taskPackagePreBaseline;
  }
}

